import React from 'react';
// eslint-disable-next-line no-restricted-imports
import ThreadsDropdown from 'plaid-threads/Dropdown';

const Dropdown = (props) => {
  return <ThreadsDropdown {...props} />;
};

export default Dropdown;
